/**
 * @name vegas drop down
 * @copyright by vegas s.
 * @date: 03.04.2020
 * @version  1.0
 *
 */

var $document = $(document),
	toggle = '[data-toggle=vg-dropdown]';

window.vegasDropdown = {
	container: '.vg-dropdown',
	content: '.vg-dropdown-content',
	
	init: ($self) => {
		var $container = $self.closest(vegasDropdown.container),
			$drop = $container.find(vegasDropdown.content),
			placement = $self.data('placement') || 'left',
			width = $self.data('width') || '';
		
		$drop.addClass(placement);
		$drop.css('width', width);
		$self.attr('area-expanded', false);
	},
	
	open: ($self) => {
		var $container = $self.closest(vegasDropdown.container),
			$drop = $container.find(vegasDropdown.content),
			$drops = $('body').find(toggle);
		
		if ($drop.hasClass('show')) {
			$drop.removeClass('show');
			$self.attr('area-expanded', false);
		} else {
			$drops.each(function () {
				$(this).closest(vegasDropdown.container).find(vegasDropdown.content).removeClass('show');
				$(this).attr('area-expanded', false);
			});
			
			$drop.addClass('show');
			$self.attr('area-expanded', true);
		}
	},
	
	close: (e) => {
		var $container = $(vegasDropdown.container),
			$drop = $container.find(vegasDropdown.content);
		
		if ($container.has(e.target).length === 0) {
			$drop.removeClass('show');
			$('body').find(toggle).attr('area-expanded', false);
		}
	}
};

$document.ready(function () {
	$(toggle).each(function () {
		vegasDropdown.init($(this));
	});
});

$document.on('click', toggle, function () {
	vegasDropdown.open($(this));
	
	return false;
});

$(document).mouseup(function (e) {
	vegasDropdown.close(e);
	
	return false;
});